import React, { Component } from 'react';
import { Route, Switch } from 'react-router';

import * as ROUTES from 'config/routes';
import FaceVisitsList from './facevisit-list';
import { PageContent } from 'components';
import { PageContainer } from 'smart-components';
import { userIsAuthenticatedRedir } from 'hocs/auth';

class FaceVisits extends Component {
	render() {
		return (
			<PageContainer>
				<PageContent>
					<PageContent.Main>
						<Switch>
							<Route
								exact
								path={ROUTES.FACE_VISITS}
								component={FaceVisitsList}
							/>
						</Switch>
					</PageContent.Main>
				</PageContent>
			</PageContainer>
		);
	}
}

export default userIsAuthenticatedRedir(FaceVisits);



// WEBPACK FOOTER //
// ./src/pages/face-visits/index.js